var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-secondary"},[_c('div',{staticClass:"d-flex justify-content-between p-0 py-1",class:{container: _vm.container, 'px-2': !_vm.container}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }